"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const JoinBroadcast_1 = tslib_1.__importDefault(require("../../../../ui-lib/Buttons/JoinBroadcast"));
const Icons_1 = tslib_1.__importDefault(require("../../../../ui-lib/Icons"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
const ModularJoinBroadcastButton = (0, mobx_react_lite_1.observer)(({ icon: ProvidedIcon, onClick, broadcastOptions, onZeroBitrate, active, classes = {
    root: {},
    icon: {},
}, label = "Stream Broadcast Toggle Button", setCallId, callId, setOwnerCall, setCall, streamKey, clientReferrer, sfuOptions, videoUserId, ...props }) => {
    var _a, _b;
    const componentName = "<BroadcastButton/>";
    /**
     * Access EncoderUiContext & destructure API state
     */
    const encoderCtx = (0, react_1.useContext)(context_1.EncoderUiContext);
    const callCtx = (0, react_1.useContext)(context_1.CallContext);
    /**
     * Grab the videoClient supplied from the encoder.
     */
    const videoClient = (0, react_1.useContext)(context_1.VideoClientContext);
    const isTogglingBroadcast = (0, react_1.useRef)(false);
    (0, ErrorBoundary_1.useUndefinedStoreError)((encoderCtx === null || encoderCtx === void 0 ? void 0 : encoderCtx.mediaStreamController) != null && videoClient != null && callCtx != null, componentName);
    (0, react_1.useEffect)(() => {
        if (onZeroBitrate) {
            callCtx.zeroBitrateHandler.push(onZeroBitrate);
        }
        return () => {
            callCtx.zeroBitrateHandler = callCtx.zeroBitrateHandler.filter((h) => h !== onZeroBitrate);
        };
    }, [callCtx, onZeroBitrate]);
    (0, react_1.useEffect)(() => {
        (0, mobx_1.reaction)(() => callCtx.call, (newCall, oldCall) => {
            var _a;
            setCall === null || setCall === void 0 ? void 0 : setCall(newCall);
            setCallId === null || setCallId === void 0 ? void 0 : setCallId((_a = newCall === null || newCall === void 0 ? void 0 : newCall.id) !== null && _a !== void 0 ? _a : null);
            if (newCall === null || newCall === void 0 ? void 0 : newCall.isOwner) {
                setOwnerCall === null || setOwnerCall === void 0 ? void 0 : setOwnerCall(newCall);
            }
        });
    }, [callCtx, setCall, setCallId, setOwnerCall]);
    const activeState = active !== null && active !== void 0 ? active : callCtx.isBroadcasting;
    const callOptions = {
        userId: videoUserId,
        clientReferrer,
        sfu: sfuOptions,
        streamKey,
    };
    async function handleJoinBroadcast() {
        if (encoderCtx && videoClient && callCtx && !isTogglingBroadcast.current) {
            isTogglingBroadcast.current = true;
            await callCtx.toggleBroadcast(callId !== null && callId !== void 0 ? callId : callOptions, broadcastOptions, encoderCtx.mediaStreamController, videoClient);
            isTogglingBroadcast.current = false;
        }
    }
    /**
     * handleClick function wrapped in global Error handler (to trigger ErrorBoundary).
     * */
    const handleClick = onClick !== null && onClick !== void 0 ? onClick : (0, ErrorBoundary_1.useUIEventError)(handleJoinBroadcast, componentName);
    const iconClasses = {
        root: {
            height: 15,
            ...((_b = (_a = classes === null || classes === void 0 ? void 0 : classes.icon) === null || _a === void 0 ? void 0 : _a.root) !== null && _b !== void 0 ? _b : {}),
        },
    };
    const icon = ProvidedIcon !== null && ProvidedIcon !== void 0 ? ProvidedIcon : react_1.default.createElement(Icons_1.default, { iconName: "broadcast", classes: iconClasses });
    return (react_1.default.createElement(JoinBroadcast_1.default, { active: activeState, activeClass: "video-button--active lv-button--active", classes: classes, inactiveClass: null, "data-selenium": "broadcast-stream-button", icon: icon, onClick: handleClick, disabled: encoderCtx.mediaStreamController.videoDeviceId == null &&
            encoderCtx.mediaStreamController.audioDeviceId == null, label: label, ...props }));
});
/**
 *
 * @visibleName Broadcast Button
 */
const JoinBroadcastButtonWithErrorBoundary = ({ icon: ProvidedIcon, label = "Stream Broadcast Toggle Button", broadcastOptions, classes, ...props }) => {
    const icon = react_1.default.createElement(Icons_1.default, { iconName: "broadcast", classes: classes === null || classes === void 0 ? void 0 : classes.icon });
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => (react_1.default.createElement(JoinBroadcast_1.default, { "data-selenium": "broadcast-stream-button", disabled: true, classes: classes, icon: ProvidedIcon !== null && ProvidedIcon !== void 0 ? ProvidedIcon : icon, label: label, onClick: undefined, active: false, ...props })) },
        react_1.default.createElement(ModularJoinBroadcastButton, { classes: classes, label: label, broadcastOptions: broadcastOptions, ...props })));
};
exports.default = JoinBroadcastButtonWithErrorBoundary;
//# sourceMappingURL=JoinBroadcast.js.map